"use client";

import { useEffect } from "react";

import { usePathname } from "next/navigation";

import {
  ensureLegacyGlobals,
  publishAdtAnalytics,
  savePrePageName,
} from "@/lib/analytics/adt-analytics";

import { useCampaign } from "@/contexts/campaignProvider.context";

export function AdtAnalytics() {
  const pathname = usePathname() ?? "/";
  const campaign = useCampaign();

  useEffect(() => {
    ensureLegacyGlobals();

    if (window.analyticsObj?.pageName) {
      savePrePageName();
    }

    const publish = () => publishAdtAnalytics({ pathname, campaign });

    publish();
    window.addEventListener("load", publish, { once: true });
    window.addEventListener("pagehide", savePrePageName);

    return () => {
      window.removeEventListener("load", publish);
      window.removeEventListener("pagehide", savePrePageName);
    };
  }, [pathname, campaign]);

  return null;
}
